import React from 'react';

import { Tooltip } from '@schoolinks/ui-components';
import cn from 'classnames';

import { string } from 'prop-types';

import Chip from '@mui/material/Chip';

import s from './Beta.css';

const Beta = ({ tooltip, tooltipPlacement, className }) => (
  <Tooltip
    placement={tooltipPlacement}
    title={tooltip}
    tooltipClass={s.tooltip}
  >
    <Chip
      variant="filled"
      className={cn(s.chip, className)}
      classes={{
        label: s.label,
      }}
      label="BETA"
    />
  </Tooltip>
);

Beta.propTypes = {
  tooltip: string,
  tooltipPlacement: string,
  className: string,
};

Beta.defaultProps = {
  tooltip: 'This feature is still in beta, so changes may occur.',
  tooltipPlacement: 'bottom',
  className: undefined,
};

export default Beta;
